import Item from "../../../core/items/Item"
import PG from "../../../core/assets/oot/boss/OoT_Phantom_Ganon.png"

export const SimplePG = () => {

    return <Item
        image={PG}
        isObtained={true}
        id={"Boss PG"}
        onClick={() => { }}
        title="Boss PG 4"
    />


}